// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/3823
import type { PAPEventGeneric } from "../base/event";

// Event_name: 'click.dash_multimedia'
// Description: Event that fires when a user clicks on a search result
// Owner: dash-exp-find-and-discover
export type Click_DashMultimedia = PAPEventGeneric<
  'dash',
  'click',
  'dash_multimedia',
  {
    // id that groups all queries in a single "session" for logging
    searchSessionId?: string;
    // File Type category as defined in react constants (FileTypeCategory), possible values are file type category values as file, folder. This is not an enum as there are constant changes to this category enum and there is no way to force updating this property too
    fileTypeCategory?: string;
    // App filters selected
    // e.g. “contact”, “contact,gsuite”
    // These values are going to be sorted, global, code defined, Dropbox owned data that tags the "type" of a search result.
    activeFilters?: string;
    // Boolean for determining if the event and associated result has OCR text extracted from it
    hasOcrText?: boolean;
  }
>;

export function PAP_Click_DashMultimedia(properties?: Click_DashMultimedia['properties']): Click_DashMultimedia {
  return <Click_DashMultimedia>{
    class: 'dash',
    action: 'click',
    object: 'dash_multimedia',
    properties,
  };
}
